module.exports = __webpack_public_path__ + "assets/bells.93da4d7b.svg";